/**
 * @module registration/creative/components/substep2_1
 */

import React, { Component, PropTypes } from 'react';
import pick from 'lodash/pick'
import pickBy from 'lodash/pickBy'
import identity from 'lodash/identity'
import { SubmissionError } from 'redux-form';
import { updateUserRequest, profileDefaults } from 'common/ducks/user';
import SettingsForm from 'registration/creative/components/account_settings_form';
import { trackGoogle } from 'common/tracking';


/**
 * Substep 2.1 of creative registration.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Substep2_1 extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      fetchCountriesIfNeeded, fetchPayoutAccounts, fetchTimezonesIfNeeded, nextSubstep
    } = this.props;

    fetchCountriesIfNeeded();
    fetchTimezonesIfNeeded();
    fetchPayoutAccounts();

    trackGoogle("registration", "verified email", "creative");

    if (this.shouldRedirect(this.props)) {
      nextSubstep();
    }
  }

  shouldRedirect({ registrationSubmittedAt, registrationReopenedAt }) {
    return registrationSubmittedAt || registrationReopenedAt;
  }

  componentDidUpdate(prevProps) {
    const { nextSubstep } = this.props;

    if (!this.shouldRedirect(prevProps) && this.shouldRedirect(this.props)) {
      nextSubstep();
    }
  }

  handleSubmit(formData) {
    const {user, nextSubstep, updateUserLocal} = this.props
    const fieldsToUpdate = [
      'first_name', 'last_name', 'date_of_birth', 'address_line_1', 'address_line_2',
      'city', 'state', 'postal_code', 'country', 'phone_number', 'user_timezone'
    ];
    return updateUserRequest(user.profile_data.id, pick(formData, fieldsToUpdate))
      .then((res) => {
        nextSubstep()
        updateUserLocal(res.data)
      })
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  render() {
    const { user, payoutAccounts } = this.props;

    /* wait until payout accounts are loaded */
    if (!payoutAccounts) {
      return null;
    }

    /* get non-empty values from `profile_data`, otherwise use values from `profileDefaults` */
    const initialValues = {
      ...profileDefaults,
      ...pickBy(user.profile_data, identity),
      payout_accounts: payoutAccounts
    }

    return (
      <div className="row align-center">
        <div className="columns small-16 medium-10">
          <div className="step-header">
            <h2>Let&apos;s create your account.</h2>
          </div>
          <SettingsForm
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            countryChoices={user.countries}
            tzChoices={user.timezones}
          />
        </div>
      </div>
    );
  }
}

Substep2_1.propTypes = {
  user: PropTypes.object.isRequired,
  payoutAccounts: PropTypes.array,
  fetchCountriesIfNeeded: PropTypes.func.isRequired,
  fetchTimezonesIfNeeded: PropTypes.func.isRequired,
  fetchPayoutAccounts: PropTypes.func.isRequired,
  updateUserLocal: PropTypes.func.isRequired,
  nextSubstep: PropTypes.func,
  registrationReopenedAt: PropTypes.string,
  registrationSubmittedAt: PropTypes.string,
};

export default Substep2_1;



// WEBPACK FOOTER //
// ./registration/creative/components/substep2_1.jsx